import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp, Container } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import * as PIXI from 'pixi.js';
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { isMobile } from "react-device-detect";
import { TIMER } from "../../core/utills";
import withSkullContainerConfiguration from "./configuration/withstreakeffectconfiguration";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as symbolActions } from "../../core/reducers/symbolStateReducer";
import { actions as reelgridAction } from '../../core/reducers/reelgridStateReducer';
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { Baseparticle } from "../../core/components/effect/baseparticle";
import { PathTween } from "../../core/components/effect/pathtween";
import { configGame } from "../../data/config"
import { GlitchFilter } from '@pixi/filter-glitch';

interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;


}

interface IStateToProps {
    [x: string]: any;

}

interface IDispatchToProps {

}

interface IState {
    [x: string]: any;
}

class StreakEffect extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected streakEffect: any;
    protected ui_mode: string;
    protected displayUI: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.state = {
            uiElements: [],
            lang: "en"
        }
        this.streakEffect = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }

        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }


    bindUI() {
        this.layoutChange(this.props.layoutMode);
    }


    initializeObjectInVariable() {

    }

    handleRotation(isFeatureShown: any) {

    }

    showHighlightedSkull(nextProps: any) {

    }

    componentDidMount() {
        this.initializeObjectInVariable();
        this.bindUI();
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return true;
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any,) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        })
    }

    render() {

        return (
            this.displayUI && this.displayUI.map((i: any) =>
                <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                    id={i.id} {...i} app={this.app} configGame={this.props.configGame} 
                    x = {this.props.streakEffectCoordinate[0] * configGame.SYMBOL_WIDTH} 
                    y = {this.props.streakEffectCoordinate[1] * configGame.SYMBOL_HEIGHT}
                    scope={this} />
            )

        )
    }

}

export default withPixiApp(connect(
    (state: Pick<IStore, 'applicationState' | 'gridsState' | 'skullState' | 'streakEffectsState'>): IStateToProps =>
    ({

    }),
    (dispatch: Dispatch): IDispatchToProps => ({

    }))(withSkullContainerConfiguration(StreakEffect)));